import { Ii18nInterpolationObject } from "src/@types/i18next";
import { ourContactsTrns } from "../trns";
import { IContacts } from "../types";

export const getContactItems = (
  contacts: IContacts
): Ii18nInterpolationObject[] => {
  if (!contacts) return [];
  const { email, address } = contacts;

  return [
    { i18nKey: ourContactsTrns.ourContactsEmail, i18nParams: { email } },
    { i18nKey: ourContactsTrns.ourContactsAddress, i18nParams: { address } },
  ];
};
